import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export interface ToastMessage {
  message: string;
  type: 'success' | 'error' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private _toasts: BehaviorSubject<ToastMessage[]> = new BehaviorSubject<ToastMessage[]>([]);

  get toasts(): Observable<ToastMessage[]> {
    return this._toasts.asObservable();
  }

  showToast(message: string, type: 'success' | 'error' | 'info') {
    const currentToasts = this._toasts.getValue();
    const newToast: ToastMessage = {message, type};
    this._toasts.next([...currentToasts, newToast]);
    setTimeout(() => this.removeToast(newToast), 20000);
  }

  removeToast(toast: ToastMessage) {
    const currentToasts = this._toasts.getValue();
    this._toasts.next(currentToasts.filter(t => t !== toast));
  }
}
